// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__pXIEV","large":"styles_large__1mdKL"};